import { Building2Icon, HandshakeIcon, UserIcon } from 'lucide-react'
import { useState } from 'react'

import { EmployerOnboardingPage, useOnboardingStep } from 'components/hooks/employer_onboarding/useOnboardingStep'
import { authnPartnersUserRegistrations } from 'rails_routes'
import { BorderedRadioButton, Button, RadioGroup, usePageTitle } from 'slab'
import { useWindowLocation } from 'utils/windowLocation'

import { CenteredLayout } from '../CenteredLayout'

type UserType = 'employee' | 'company' | 'broker'

export function GetStartedPage () {
  usePageTitle('Get Started')

  const [selectedUserType, setSelectedUserType] = useState<UserType | null>(null)
  const { navigateToNextStep, navigateToStep } = useOnboardingStep()
  const { assign } = useWindowLocation()

  const handleNext = () => {
    if (selectedUserType === 'company') {
      navigateToNextStep()
    } else if (selectedUserType === 'employee') {
      navigateToStep(EmployerOnboardingPage.EMPLOYEE)
    } else if (selectedUserType === 'broker') {
      assign(authnPartnersUserRegistrations.new())
    }
  }

  return (
    <CenteredLayout verticallyCentered>
      <CenteredLayout.Header
        heading='Welcome to Thatch!'
        subheading="To get started, tell us a bit about yourself and how you'll be using Thatch."
      />
      <CenteredLayout.Container hideCard padded={false}>
        <RadioGroup name='user_type' layout='horizontal' gap={4}>
          <div className='grid md:grid-cols-3 gap-4 w-full'>
            <BorderedRadioButton
              value='employee'
              label={
                <div className='flex items-center gap-2'>
                  <UserIcon className='w-5 h-5' />
                  <span>Employee</span>
                </div>
              }
              description='I work for a company that provides health benefits through Thatch.'
              onChange={() => setSelectedUserType('employee')}
              checked={selectedUserType === 'employee'}
              size='large'
            />
            <BorderedRadioButton
              value='company'
              label={
                <div className='flex items-center gap-2'>
                  <Building2Icon className='w-5 h-5' />
                  <span>Company</span>
                </div>
              }
              description="I'm an employer who wants to offer better health benefits for my team."
              onChange={() => setSelectedUserType('company')}
              checked={selectedUserType === 'company'}
              size='large'
            />
            <BorderedRadioButton
              value='broker'
              label={
                <div className='flex items-center gap-2'>
                  <HandshakeIcon className='w-5 h-5' />
                  <span>Broker</span>
                </div>
              }
              description="I'm a broker or partner who wants to help clients offer better health benefits."
              onChange={() => setSelectedUserType('broker')}
              checked={selectedUserType === 'broker'}
              size='large'
            />
          </div>
        </RadioGroup>
      </CenteredLayout.Container>
      <div className='mt-6'>
        <CenteredLayout.Buttons>
          <Button
            variant='primary'
            onClick={handleNext}
            disabled={!selectedUserType}
          >
            Next
          </Button>
        </CenteredLayout.Buttons>
      </div>
    </CenteredLayout>
  )
}
